import { resetEventLog as resetEventLogDiagram, rebuildPVDiagram, resetTimeFilterDefaults} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type VariantsProps = ApiMethodBase & {}

export const resetEventLog = ({
    eventEmitter,
}: VariantsProps) => {
    resetEventLogDiagram();
    if (apiProvider.getActiveAction() ==='process_miner') rebuildPVDiagram('resetEventLog');
    const values = resetTimeFilterDefaults();
    //reGenerateArrays();
    eventEmitter.emit(Event.resetFilter);
    eventEmitter.emit(Event.resetTimeFilter, values);
    eventEmitter.emit(Event.resetTasksFilter, resetValues);
    eventEmitter.emit(Event.resetEventLog); // updates sidebar
    // how to update diagram and metrics ?
};
